import { SessionService as session } from "../services/SessionService";
import { useEffect, useState } from "react";
import { isEmail, isName, isPhone } from "../services/validators";

export const useSession = () => {
    const [, ur] = useState(null);

    useEffect(() => {
        return session.subscribe(() => ur(Date.now()));
    }, []);

    const update = (key, value) => {
        session.set(key, value);
        // if(!isProd()) console.log(read());
    };

    const batchUpdate = (object) => {
        session.merge(object);
        // if(!isProd()) console.log(read());
    };

    const read = (key) => {
        return session.get(key);
    };

    const getAppointmentPayload = () => {
        return session.getAppointmentPayload();
    };

    const getAppointmentNewPayload = () => {
        const oldPayload = session.getAppointmentPayload();
        return {
            prodotto: oldPayload.prodotto,
            FiscalCode: oldPayload.codiceFiscale,
            Date: oldPayload.data.split("T")[0],
            SlotId: read("orarioSceltoId"),
            BranchId: oldPayload.filiale,
            nome: oldPayload.nome,
            cognome: oldPayload.cognome,
            email: oldPayload.email,
            cellulare: oldPayload.cellulare,
            privacyInterncommoffer: `${oldPayload.privacyInterncommoffer}`,
            // privacyExtcommoffer: `${oldPayload.privacyExtcommoffer}`,
            // privacyOtherservice: `${oldPayload.privacyOtherservice}`,
            // privacyProfilazione: `${oldPayload.privacyProfilazione}`,
            tipoOccupazione: `${oldPayload.impiego}`,
            mediacode: oldPayload.mediacode,
            utmCampaign: oldPayload.utm_campaign,
            utmContent: oldPayload.utm_content,
            utmDate: oldPayload.utm_date,
            utmHistory: oldPayload.utm_history,
            utmMedium: oldPayload.utm_medium,
            utmSource: oldPayload.utm_source,
            utmTerm: oldPayload.utm_term,
            mediacodeInt: "",
            gclId: oldPayload.gclid,
            clientId: oldPayload.clientId,
            // nuovi campi
            AppointmentTime: read("orarioSceltoLabel"),
            BranchName: read("filialeScelta").nomeFiliale,
            BranchAddress: read("filialeScelta").indirizzo,
            BranchTown: read("filialeScelta").citta,
        };
    };

    const isAppointmentPayloadReady = (weNeedFullPayload = true) => {
        document.querySelectorAll(".crea-appto-error").forEach((el) => {
            el.classList.add("hidden");
        });
        let isReady = true;
        // const requiredKeys = ["nome", "cognome", "email", "cellulare", "codiceFiscale", "privacyExtcommoffer", "privacyOtherservice", "privacyProfilazione"];
        const requiredKeys = ["nome", "cognome", "email", "cellulare", "codiceFiscale"];
        requiredKeys.push("filiale");
        requiredKeys.push("data");
        requiredKeys.push("privacyInterncommoffer");
        let focusOn = "";
        let focusOnError = ".full-form-appto-error";
        let focusOnPosition = "center";

        const payload = getAppointmentPayload();
        payload["privacyInterncommoffer"] = "1";

        for (let key of requiredKeys) {
            // if (["privacyExtcommoffer", "privacyOtherservice", "privacyProfilazione"].includes(key) && (!payload.hasOwnProperty(key) || payload[key] == -1)) {
            //     isReady = false;
            //     focusOn = ".tos-list-component";
            //     focusOnPosition = "start";
            //     focusOnError = ".tos-list-component-appto-error";
            //     break;
            // }
            if (["nome", "cognome"].includes(key) && (!payload[key] || !isName(payload[key]))) {
                isReady = false;
                focusOn = ".full-form";
                break;
            }
            if ("email" == key && (!payload[key] || !isEmail(payload[key].replace(".invalid", "")))) {
                isReady = false;
                focusOn = ".full-form";
                break;
            }
            if ("cellulare" == key && (!payload[key] || !isPhone(payload[key]))) {
                isReady = false;
                focusOn = ".full-form";
                break;
            }
            if (weNeedFullPayload && key == "privacyInterncommoffer" && (!payload[key] || payload[key] != "1")) {
                isReady = false;
                focusOn = ".tos-sic";
                focusOnError = ".tos-list-component-sic-appto-error";
                break;
            }
            if (!payload.hasOwnProperty(key)) {
                if (!weNeedFullPayload && "privacyInterncommoffer" == key) {
                    isReady = true;
                } else {
                    console.log(key + " Richiesta ma non presente");
                    isReady = false;
                }
                break;
            }

            if ("codiceFiscale" == key && payload["codiceFiscale"]) {
                payload["codiceFiscale"] = payload["codiceFiscale"].toUpperCase();
            }
        }

        if (focusOn.length) {
            let destinationNode = document.querySelector(focusOn);
            if (null != destinationNode) {
                destinationNode.scrollIntoView({
                    behavior: "smooth",
                    block: focusOnPosition,
                });
            }

            if (null != document.querySelector(`.crea-appto-error${focusOnError}`)) {
                document.querySelector(`.crea-appto-error${focusOnError}`).classList.remove("hidden");
            }
        }

        return isReady;
    };

    const isAppointmentPayloadAlmostReady = () => {
        return isAppointmentPayloadReady(false);
    };

    const canWeSkipLuogoPage = () => {
        return null != read("filialeScelta");
    };

    const setState = (state) => {
        update("state", state);
    };

    const isCompassQuintoSite = () => {
        return window.location.host.indexOf("compassquinto") != -1;
    };

    // handle browser back button
    const reloadAppOnBack = () => {
        window.addEventListener("popstate", (evt) => {
            evt.preventDefault();
            setState(0);
            window.location.href = `${window.location.origin}/${process.env.REACT_APP_FOLDER}`;
            return false;
        });
    };

    // basta che isAppointmentPayloadReady() sia true
    const canISkipAllPages = () => {
        return isAppointmentPayloadReady();
    };
    // puo arrivare all'ultima pagina prima di fissare,
    // ma deve seguire logiche di useCodiceFiscale:79 e :88
    const canISkipToLastPage = () => {};
    // deve avere filiali, filialescelta, etc per renderizzare slides
    // se c'è anche un codFiliale_external, deve spostare (con piccolo timeout) la splide delle subs
    //   per forzare cambio in data e orari
    const canISkipFirstPage = () => {};
    // basta che restituisca codicefiscale_external
    const canISkipCfPage = () => {
        return read("codiceFiscale_external");
    };

    return {
        update,
        batchUpdate,
        read,
        setState,
        getAppointmentPayload,
        isAppointmentPayloadReady,
        isAppointmentPayloadAlmostReady,
        reloadAppOnBack,
        canISkipAllPages,
        canISkipToLastPage,
        canISkipFirstPage,
        canISkipCfPage,
        canWeSkipLuogoPage,
        getAppointmentNewPayload,
        isCompassQuintoSite,
    };
};
